import { render } from "./EmailAlertOutline.vue?vue&type=template&id=956bfb78"
import script from "./EmailAlertOutline.vue?vue&type=script&lang=js"
export * from "./EmailAlertOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__